// src/encounter/patient-reported-answers-dialog.tsx
// "View answers" on a Patient-reported entry: the patient's submitted answers, read-only, in the order they were stored,
// with the score as stored. No bands, colours or alerts, and item 9 is shown like every other item (orchestrator, 22 Oct).
import { Button, cn, Modal, TEXT_ROLE_CLASSES } from '@scripsteam/scrips-signal-ds';
import { scoreLine, submittedOn, type PatientReportedResponse } from './lib/patient-reported';

export interface PatientReportedAnswersDialogProps {
  response: PatientReportedResponse;
  onClose: () => void;
}

export function PatientReportedAnswersDialog({ response, onClose }: PatientReportedAnswersDialogProps) {
  const when = submittedOn(response.authored);
  return (
    <Modal
      open
      onClose={onClose}
      title={scoreLine(response)}
      description={when ? `Submitted by the patient on ${when}` : 'Submitted by the patient'}
      size="md"
      scrollBody
      footer={
        <Button type="button" variant="secondary" size="sm" onClick={onClose}>
          Close
        </Button>
      }
    >
      {response.answers.length === 0 ? (
        <p className={TEXT_ROLE_CLASSES.body}>No answers were stored with this questionnaire.</p>
      ) : (
        <ol className="flex flex-col gap-4" aria-label="Answers">
          {response.answers.map((a) => (
            <li key={a.linkId} className="flex flex-col gap-1">
              <span className={TEXT_ROLE_CLASSES.body}>{a.question}</span>
              <span className={cn(TEXT_ROLE_CLASSES['body-emphasis'])}>{a.answer || 'No answer stored'}</span>
            </li>
          ))}
        </ol>
      )}
    </Modal>
  );
}
